/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A traditional English haiku has three lines with 5, 7, and 5 syllables respectively — 17 syllables in total.`)
};

const es_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un haiku inglés tradicional tiene tres líneas con 5, 7 y 5 sílabas respectivamente — 17 sílabas en total.`)
};

const de_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein traditionelles englisches Haiku hat drei Zeilen mit 5, 7 beziehungsweise 5 Silben — insgesamt 17 Silben.`)
};

const nl_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een traditionele Engelse haiku heeft drie regels met respectievelijk 5, 7 en 5 lettergrepen — 17 lettergrepen in totaal.`)
};

const fr_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un haïku anglais traditionnel comporte trois vers de 5, 7 puis 5 syllabes respectivement — soit 17 syllabes au total.`)
};

const it_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un haiku inglese tradizionale ha tre righe con rispettivamente 5, 7 e 5 sillabe — 17 sillabe in totale.`)
};

const pt_br2_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um haiku inglês tradicional tem três linhas com, respectivamente, 5, 7 e 5 sílabas — 17 sílabas no total.`)
};

const pt_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um haiku inglês tradicional tem três linhas com, respetivamente, 5, 7 e 5 sílabas — 17 sílabas no total.`)
};

const ja_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伝統的な英語俳句は、それぞれ5音節・7音節・5音節の3行から成り、合計17音節です。`)
};

const zh_syl_haiku_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传统的英语俳句由三行组成，音节数分别为5、7、5，共计17个音节。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq1_a", locale)
	if (locale === "en") return en_syl_haiku_faq1_a(inputs)
	if (locale === "es") return es_syl_haiku_faq1_a(inputs)
	if (locale === "de") return de_syl_haiku_faq1_a(inputs)
	if (locale === "nl") return nl_syl_haiku_faq1_a(inputs)
	if (locale === "fr") return fr_syl_haiku_faq1_a(inputs)
	if (locale === "it") return it_syl_haiku_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq1_a(inputs)
	if (locale === "pt") return pt_syl_haiku_faq1_a(inputs)
	if (locale === "ja") return ja_syl_haiku_faq1_a(inputs)
	return zh_syl_haiku_faq1_a(inputs)
};